// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"f0a0314e","272":"f38cc336","368":"28d38256","419":"d8cb3bb3","440":"6e95660a","721":"775d595e","779":"0ff144fe","800":"da0a5407","804":"ab479bf3","913":"3b4be41c","929":"14d01682"}[chunkId] + ".chunk.js";
};